import { axiosInstance } from 'apis';
import { getBaseURL } from 'utility/baseURL';

const baseUrl = getBaseURL();

const EHome = {
	categories: baseUrl + '/keepaSite/Categories',
	sms: baseUrl + '/keepaSite/RequestApplicationDownloadlink',
};

const homeAPIs = {
	categories: (data, option = {}) => axiosInstance.post(EHome.categories, data, option),
	sendSMS: (data, option = {}) => axiosInstance.post(EHome.sms, data, option),
};

export { EHome, homeAPIs };
